import React from "react";
import { Button, CircularProgress } from "@mui/material";
import ArchiveIcon from "@mui/icons-material/Archive";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import AddIcon from '@mui/icons-material/Add';

/**
 * 
 * @param {String} text* Button text 
 * @param {Boolean} processing* loading indicator 
 * @param {Node} icon Button icon 
 * @param {Boolean} disabled* disabled button indecator  
 * @param {String} type* Button type ["update","import", "export", "secondary", "dark", "danger"] 
 * @param {Object} action* Button action (function to be passed to onClick event handler) 

 * @returns 
 */
const CustomButton = ({ text, icon, disabled, processing, type, action }) => {
  if (processing) {
    return (
      <Button
        startIcon={<CircularProgress size={20} sx={{ color: "#ffffff" }} />}
        variant="contained"
        disabled={true}
        sx={{
          textTransform: "none",
          fontSize: ".875rem",
          fontWeight: 500,
          letterSpacing: "-0.47px",
          "&.Mui-disabled": {
            backgroundColor:
              type === "export" || type === "import" || type === "secondary"
                ? "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)"
                : type === "dark"
                ? "#050D2E"
                : "#1492AF",
            opacity: 0.2,
            color: "#ffffff",
          },
        }}
        disableElevation
      >
        {text}
      </Button>
    );
  } else {
    return (
      <Button
        variant="contained"
        startIcon={
          icon ? (
            icon
          ) : type === "import" ? (
            <UnarchiveIcon />
          ) : type === "export" ? (
            <ArchiveIcon />
          ) : type ==="add" ? (
            <AddIcon/>
          ) : null
        }
        sx={{
          "& .MuiButton-startIcon": {
            "& :nth-of-type(1)": {
              fontSize: "15px",
            },
            marginRight: "4px",
          },
          "&.Mui-disabled": {
            backgroundColor:
              type === "export" || type === "import" || type === "secondary"
                ? "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)"
                : type === "dark"
                ? "#050D2E"
                : "#1492AF",
            opacity: 0.2,
            color: "#ffffff",
          },
          background:
            type === "export" || type === "import" || type === "secondary"
              ? "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)"
              : type === "dark"
              ? "#050D2E"
              : type === "danger"
              ? "red"
              : "#1492AF",
          textTransform: "none",
          fontSize: ".875rem",
          fontWeight: type === "import" || type === "export" ? 500 : 400,
          color:
            type === "import" || type === "export" || type === "secondary"
              ? "#050D2E"
              : "#ffffff",
          letterSpacing: "-0.47px",
          padding: "10px",
          lineHeight: "16px",
          ...((type === "import" ||
            type === "export" ||
            type === "secondary") && {
            border: "1px solid #DBDEE6",
          }),
          " :hover": {
            background:
              type === "export" || type === "import" || type === "secondary"
                ? "linear-gradient(180deg, #FFFFFF 0%, #F3F5F7 100%)"
                : type === "dark"
                ? "#050D2E"
                : type === "danger"
                ? "red"
                : "#1492AF",
            opacity: 0.9,
          },
        }}
        disabled={disabled}
        disableElevation
        onClick={action}
      >
        {text}
      </Button>
    );
  }
};

export default CustomButton;
